import options from './auxiliary-chart.component';

export default {
    selector: 'dtChartProximityAuxiliaryChart',
    options
};
